import { Controller } from "@hotwired/stimulus"

const DOWNLOAD_TYPE_ENABLED = "Anzeigen"
const SIZE_FIXED = "Feste Größe"
const TYPE_LIGHTBOX = "Lightbox"

export default class extends Controller {
  static targets = [
    "sizeContainer",
    "downloadTypeSelect",
    "heightInput",
    "sizeSelect",
    "typeSelect",
    "widthInput",
    "downloadButtonOutput",
    "lightboxOutput",
    "sizeOutput"
  ]

  connect() {
    this.options = {}
    this.updateEmbedSettings()
  }

  updateEmbedSettings() {
    if (this.downloadType == DOWNLOAD_TYPE_ENABLED) {
      this.downloadButtonOutputTarget.innerHTML = " data-enable-download"
    } else {
      this.downloadButtonOutputTarget.innerHTML = ""
    }

    if (this.type == TYPE_LIGHTBOX) {
      this.lightboxOutputTarget.innerHTML = " data-lightbox"
    } else {
      this.lightboxOutputTarget.innerHTML = ""
    }

    if (this.size == SIZE_FIXED) {
      this.sizeContainerTarget.classList.remove("disable--children")
      this.sizeOutputTarget.innerHTML = ` style="width: ${this.width}px; height: ${this.height}px"`
    } else {
      this.sizeContainerTarget.classList.add("disable--children")
      this.sizeOutputTarget.innerHTML = ""
    }
  }

  get downloadType() { return this.downloadTypeSelectTarget.value }
  get height() { return this.heightInputTarget.value }
  get size() { return this.sizeSelectTarget.value }
  get type() { return this.typeSelectTarget.value }
  get width() { return this.widthInputTarget.value }
}
